import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import * as viewReducer from "containers/View/reducer";
import * as recipeReducer from "containers/Recipe/reducer";

import RecipeRow from "components/View/Rows/RecipeRow";

import RecipeTile from "components/Tiles/RecipeTile";

class RecipeItem extends React.PureComponent {
  renderTile() {
    const { recipe, isTrayUploading, onClick, handleDelete, handleConfigure, style, isUpdating } = this.props;

    return (
      <div style={style}>
        <RecipeTile
          recipe={recipe}
          handleDelete={handleDelete}
          handleConfigure={handleConfigure}
          onClick={onClick === undefined ? () => ({}) : onClick}
          isUpdating={isTrayUploading || isUpdating}
        />
      </div>
    );
  }

  renderRow() {
    const { recipe, onClick } = this.props;

    return <RecipeRow recipe={recipe} onClick={() => onClick(recipe)} />;
  }

  render() {
    const { isTile } = this.props;

    return isTile ? this.renderTile() : this.renderRow();
  }
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  handleDelete: () => dispatch(recipeReducer.deleteRecipe(ownProps.id)),
  handleConfigure: () => dispatch(recipeReducer.configureRecipe(ownProps.id))
});

const mapStateToProps = (state, ownProps) => {
  return {
    isTile: ownProps.isTile ? ownProps.isTile : viewReducer.getIsTile(state),
    recipe: recipeReducer.getRecipe(state, ownProps.id),
    isUpdating: recipeReducer.isRecipeUpdating(state, ownProps.id)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(RecipeItem);
